import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { isPreview } from '../runtime-environment/drive-env';

/**
 * 是否禁用socket连接
 */
export function shouldDisableSocket(): boolean {
    // 当这个配置为false的时候不建立房间层连接～（默认为true）
    if (!getCacConfigByKey('custom.editRoomConnection', true)) {
        return true;
    }
    return getCacConfigByKey('custom.common.disableSocket', false) && isPreview();
}

/**
 * 是否禁用网络连接
 */
export function shouldDisableNetwork(): boolean {
    return getCacConfigByKey('custom.common.disableNetwork', false);
}
